import styles from "../../ProductCard.module.scss";

import { percentageCalculator } from "../../../../utils/helpers";

export const ProductPrice = (props) => {
  const selectedPrice =
    props.finalPrice +
    percentageCalculator(
      props.selectedVariant?.price,
      props.selectedVariant?.discount_percentage,
    );
  return (
    <div className={styles.productCard_price}>
      <span
        style={{
          fontSize: "2rem",
          fontWeight: "bold",
          padding: "0 0.25rem",
          color: 'var(--color-primary)',
        }}
      >
        {props.finalPrice.toFixed(2)} €
      </span>
      {props.selectedVariant?.discount_percentage > 0 && (
        <>
          <span style={{ margin: "0 2px", display: "inline-block" }}>|</span>
          <span
            style={{
              fontSize: "1.75rem",
              fontWeight: "bold",
              textDecoration: "line-through",
              height: "fit-content",
              color: 'var(--color-red)',
            }}
          >
            ({selectedPrice.toFixed(2)} €)
          </span>
        </>
      )}
    </div>
  );
};
